import { render, staticRenderFns } from "./ProjectPhasesPanel.vue?vue&type=template&id=2018cf1c&"
import script from "./ProjectPhasesPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectPhasesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports